import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { MapView } from "@msuite/ui/map";
import { useVehicleIntegration } from "@/hooks/use-vehicle-integration";
import type { VehiclePanelBaseProps } from "../../shared";
import { TargetPin } from "./target-map-pin";
import { VehicleMapPin } from "./vehicle-map-pin";

export function VehiclePosition({ vehicleId }: VehiclePanelBaseProps) {
	/** Hooks */
	const { hasIntegration, data } = useVehicleIntegration(vehicleId);

	/** Guard */
	if (!hasIntegration) return null;

	const _latitude = data?.integrationData?.resource?.latitude_mdeg;
	const _longitude = data?.integrationData?.resource?.longitude_mdeg;

	/** Guard */
	if ([!_latitude, !_longitude].includes(true)) return null;

	const latitude = _latitude! / 1_000_000;
	const longitude = _longitude! / 1_000_000;

	/** Render */
	return (
		<ContentCard
			title="Position"
			icon={icon("Map")}
			contentClassName="!p-0"
			layoutId="vehicle-position"
		>
			<div className="h-87.5">
				<MapView
					apiKey={process.env.PUBLIC_GOOGLE_MAPS_API_KEY!}
					mapId={process.env.PUBLIC_GOOGLE_MAPS_MAP_ID!}
					markers={[
						{
							id: "vehicle-position",
							latitude,
							longitude,
							render: () => <VehicleMapPin />,
						},
					].concat(
						data?.integrationData?.resource?.dest_latitude
							? [
									{
										id: data?.integrationData.resource.objectuid,
										latitude: (data?.integrationData?.resource.dest_latitude || 0) / 1_000_000,
										longitude: (data?.integrationData?.resource.dest_longitude || 0) / 1_000_000,
										render: () => <TargetPin />,
									},
								]
							: [],
					)}
				/>
			</div>
		</ContentCard>
	);
}
